import { CustomButton, SearchBar, SwitchButton } from "components/form";
import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CustomModal, PopupModal } from "components/modals/ModalBox";
import "./OrderManagement.scss";
import useDebounce from "common/UseDebounce";
import { toastMessage } from "utils/toastMessage";
import NotFound from "common/NotFound";
import useButtonLoader from "common/UseButtonLoader";
import { searchDateFormat } from "common/InputForm";
import { FaRegEye, FaRegTrashAlt } from "react-icons/fa";
import { toast } from "sonner";
import Pagination from "react-js-pagination";
import { DatePicker } from "common/InputForm";
import { userStatusChangeApi } from "services/user";
import useFullPageLoader from "common/UseFullPageLoader";
import { dateFormat } from "utils/dateFormat";
import axios from "axios";
import { setJwtToken } from "config/axiosInstance";
import { changeOrderStatus, getOrderApi } from "services/order";
const OderManagement = () => {
  const [loader, onShow, onHide] = useFullPageLoader();
  const [orderList, setOrderList] = useState([]);
  const [search, setSearch] = useState("");
  const [searchParams, setSearchParams] = useSearchParams();
  const debouncedValue = useDebounce(search, 300);
  const [fieldName, setFieldName] = useState("");
  const [direaction, setDirection] = useState("");
  const [selected, setSelected] = useState({});
  const [statusModal, setStatusModal] = useState(false);
  const [total, setTotal] = useState(null);
  const [buttonLoader, setButtonLoader] = useButtonLoader("Yes");
  const [buttonLoaders, setButtonLoaders] = useButtonLoader("Yes");

  const activePage = +searchParams.get("page") || 1;
  let searchStartDate = searchParams.get("startDate") || "";
  let searchEndDate = searchParams.get("endDate") || "";
  const limit = +searchParams.get("limit") || 10;
  const statusValue = searchParams.get("status") || "";
  const [buttonLoaderFile, setButtonLoaderFile] = useButtonLoader("Export");
  const [orderId, setOrderId] = useState("");
  const [orderStatusValue, setOrderStatusValue] = useState("");
  const [showModal, setShowModal] = useState(false);
  // sort
  const toggleSortOrder = () => {
    setDirection(direaction === "ASC" ? "DESC" : "ASC");
  };
  const handleSort = (field) => {
    if (field === fieldName) {
      toggleSortOrder();
    } else {
      setFieldName(field);
      setDirection("ASC");
    }
  };

  // change student status
  const statusHandler = (teacherId, status) => {
    setSelected({
      ...selected,
      userId: teacherId,
      status: status === "true" ? "false" : "true",
    });
    setStatusModal(true);
  };
  /**************Change Status Handler*********************/
  const changeStatusHandler = async () => {
    try {
      setButtonLoader(true);
      const res = await userStatusChangeApi(selected);
      if (res.data.status === 200) {
        toastMessage(res.data.message, "success", "changeStatus");
        setStatusModal(false);
        orderListHandler();
      } else {
        toastMessage(res.data.message, "error", "changeStatus");
      }
    } catch (e) {
      console.log("error:", e.error);
    } finally {
      setButtonLoader(false);
    }
  };
  // //*********start Date search********* */
  const handleStartDate = (date) => {
    searchParams.set("page", 1);
    searchParams.set("startDate", searchDateFormat(date));
    setSearchParams(searchParams);
  };
  // //*********end Date search********* */
  const handleEndDate = (date) => {
    searchParams.set("page", 1);
    searchParams.set("endDate", searchDateFormat(date));
    setSearchParams(searchParams);
  };
  /*************Reset Filter Handler*********************/
  const resetFilterHandler = () => {
    searchParams.delete("status");
    searchParams.delete("page");
    searchParams.delete("startDate");
    searchParams.delete("endDate");
    searchParams.delete("plan");
    searchParams.delete("bodyShape");
    searchParams.delete("styleIdentity");

    setSearch("");
    setSearchParams(searchParams);
  };
  //*********Handel Pagination********* */
  const handlePageChange = (event) => {
    searchParams.set("page", event);
    setSearchParams(searchParams);
  };
  /**************Modal CLose*********************/
  const closeModal = () => {
    setStatusModal(false);
    setSelected({});
  };
  //-----------status-------------
  const handleStatus = (event) => {
    const value = event.target.value;
    searchParams.set("status", value);
    searchParams.set("page", 1);
    setSearchParams(searchParams);
  };

  // order list handler
  const orderListHandler = async (
    page = activePage,
    limit = "10",
    search = debouncedValue,
    sortField = fieldName,
    sortDirection = direaction,
    startDate = searchStartDate,
    endDate = searchEndDate,
    status = statusValue || "ongoing"
  ) => {
    try {
      onShow();
      const res = await getOrderApi({
        page,
        search,
        limit,
        sortField,
        sortDirection,
        startDate,
        endDate,
        status,
      });
      if (res?.data?.status === 200) {
        setTotal(res?.data?.total);
        setOrderList(res.data?.data?.order);
        onHide();
      }
    } catch (e) {
      onHide();
      toast.error(e.message);
    }
  };
  useEffect(() => {
    if (Number(activePage) === 1) {
      searchParams.delete("page");
      setSearchParams(searchParams);
    }
    orderListHandler();
  }, [
    searchParams,
    debouncedValue,
    fieldName,
    direaction,
    searchStartDate,
    searchEndDate,
    statusValue,
  ]);
  useEffect(() => {
    if (search) {
      searchParams.delete("page");
    }
  }, []);
  const handleShowModal = () => {
    setShowModal(true);
  };
  const handleCloseModal = () => {
    setShowModal(false);
  };
  const updateOrderStatus = async () => {
    try {
      const sendData = {
        orderId: orderId,
        status: orderStatusValue,
      };
      setButtonLoaders(true);
      const { data } = await changeOrderStatus(sendData);
      if (data.status === 200) {
        toast.success(data.message);
        setShowModal(false);
        setButtonLoaders(false);
        orderListHandler();
      } else {
        toast.error(data.message);
        setButtonLoaders(false);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const url = `${process.env.REACT_APP_API_URL}/export/order`;
  const downloadFile = async (
    url,
    fileName,
    params = {
      startDate: searchStartDate,
      endDate: searchEndDate,
      status: statusValue || "ongoing",
    }
  ) => {
    try {
      setButtonLoaderFile(true);
      const { headers } = setJwtToken();
      const response = await axios.get(url, {
        params,
        responseType: "blob",
        headers,
      });
      if (response.status === 200) {
        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });
        const blobUrl = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      } else {
        throw new Error("File download failed");
      }
    } catch (error) {
      console.error("Error downloading file:", error);
      if (axios.isCancel(error)) {
        console.log("Request cancelled:", error.message);
      } else {
        console.error("Error:", error.message);
      }
    } finally {
      setButtonLoaderFile(false);
    }
  };
  return (
    <>
      <div className="student_management">
        <div className="card top_card">
          <div className="dashboard_title has_child">
            <h3> Order Management</h3>

            <div className="d-flex">
              <CustomButton
                type="button"
                className="button mx-2"
                ref={buttonLoaderFile}
                onClick={() => downloadFile(url, "Order")}
              >
                Export
              </CustomButton>
            </div>
          </div>
          <div className="button_section_wrap">
            <div className="search_wrapper">
              <SearchBar
                placeholder={"Search..."}
                onChange={(e) => {
                  setSearch(e.target.value);
                  searchParams.delete("page");
                  setSearchParams(searchParams);
                }}
                value={search}
              />
              <div className="d-flex">
                <select
                  className="input form-control"
                  value={statusValue}
                  onChange={handleStatus}
                >
                  <option value="ongoing">Ongoing</option>
                  <option value="delivered">Delivered</option>
                  <option value="cancelled">Cancelled</option>
                </select>
                <DatePicker
                  className="form-control "
                  name="startDate"
                  selected={searchStartDate}
                  placeholder="Start Date"
                  onChange={(date) => handleStartDate(date)}
                  maxDate={searchEndDate}
                />
                <DatePicker
                  name="endDate"
                  className="form-control"
                  placeholder="End Date"
                  selected={searchEndDate}
                  onChange={(date) => handleEndDate(date)}
                  minDate={searchStartDate}
                />
                <CustomButton onClick={resetFilterHandler}>Reset</CustomButton>
              </div>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <div className="table_wrap">
              <table className="table custom_table">
                <thead>
                  <tr>
                    <th className="nowrap">S.No. </th>

                    <th
                      className="nowrap cursor-pointer"
                      onClick={() => handleSort("user.name")}
                    >
                      User Name
                      <span className="shorting">
                        {fieldName === "user.name"
                          ? direaction === "ASC"
                            ? "↑"
                            : "↓"
                          : "↓"}
                      </span>
                    </th>
                    <th
                      className="nowrap cursor-pointer"
                      onClick={() => handleSort("orderNumber")}
                    >
                      Order Number
                      <span className="shorting">
                        {fieldName === "orderNumber"
                          ? direaction === "ASC"
                            ? "↑"
                            : "↓"
                          : "↓"}
                      </span>
                    </th>
                    <th
                      className="nowrap cursor-pointer"
                      onClick={() => handleSort("price")}
                    >
                      Price
                      <span className="shorting">
                        {fieldName === "price"
                          ? direaction === "ASC"
                            ? "↑"
                            : "↓"
                          : "↓"}
                      </span>
                    </th>
                    <th className="nowrap text-center cursor-pointer">
                      Items
                      <span className="shorting"></span>
                    </th>
                    <th
                      className="nowrap cursor-pointer"
                      onClick={() => handleSort("createdAt")}
                    >
                      Order Date
                      <span className="shorting">
                        {fieldName === "createdAt"
                          ? direaction === "ASC"
                            ? "↑"
                            : "↓"
                          : "↓"}
                      </span>
                    </th>
                    <th
                      className="nowrap text-center cursor-pointer"
                      onClick={() => handleSort("status")}
                    >
                      Status
                      <span className="shorting">
                        {fieldName === "status"
                          ? direaction === "ASC"
                            ? "↑"
                            : "↓"
                          : "↓"}
                      </span>
                    </th>
                    <th className="nowrap text-center">View Details</th>
                  </tr>
                </thead>
                <tbody>
                  {loader}
                  {orderList && orderList.length > 0 ? (
                    orderList?.map((data, index) => {
                      return (
                        <tr key={++index}>
                          {/* <td className="nowrap">{index + 1}</td> */}
                          <td className="nowrap">
                            {++index + (activePage - 1) * 10}
                          </td>
                          <td className="nowrap">{data?.user?.name}</td>
                          <td className="nowrap">{data?.orderNumber}</td>
                          <td className="">₹{data?.price}</td>
                          <td className="text-center">{data?.itemNumber}</td>
                          <td className="nowrap">
                            {dateFormat(data?.createdAt)}
                          </td>
                          <td>
                            {
                              <select
                                className="input form-control"
                                value={data.status}
                                id="exampleFormControlSelect1"
                                onChange={(e) => {
                                  setOrderStatusValue(e.target.value);

                                  handleShowModal(true);
                                }}
                                onClick={(e) => {
                                  setOrderId(data._id);
                                }}
                              >
                                <option value="">Status</option>
                                <option value="pending">Pending</option>
                                <option value="confirmed">Confirmed</option>
                                <option value="enroute">Enroute</option>
                                <option value="reached">Reached</option>
                                <option value="delivered">Delivered</option>
                                <option value="cancelled">Cancelled</option>
                              </select>
                            }
                          </td>{" "}
                          <td>
                            {" "}
                            <div className="icon_wrap">
                              <Link
                                to={`/order-management/detail/${data?._id}`}
                                className="icon_button"
                              >
                                <FaRegEye />
                              </Link>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <NotFound
                      cols={8}
                      msg={"Order data not found"}
                      onHide={onHide}
                    />
                  )}
                </tbody>
              </table>
            </div>
            {total > limit && (
              <div className="pagination-wrapper">
                <div className="Pagination">
                  <Pagination
                    activePage={activePage}
                    previousLabel={"previous"}
                    nextLabel={"next"}
                    itemsCountPerPage={limit}
                    totalItemsCount={total}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                    hideDisabled={true}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <PopupModal
        show={statusModal}
        handleClose={closeModal}
        content="Are you sure you want to change status of this User?"
        title="Change Status"
        onShow={changeStatusHandler}
        buttonLoader={buttonLoader}
      />

      <PopupModal
        show={showModal}
        handleClose={handleCloseModal}
        content={`Are you sure want to update ${orderStatusValue} of this  order ?`}
        title="Update Order Status"
        onShow={updateOrderStatus}
        buttonLoader={buttonLoaders}
      />
    </>
  );
};

export default OderManagement;
